import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "baise",
  style: {"margin-top":"20px"}
}
const _hoisted_2 = ["onClick"]

import router from '@/router';
import { defineAsyncComponent, onMounted, reactive, computed, ref } from 'vue';
import { Session } from '@/utils/storage'
import { useStore } from 'vuex';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    asideList: {
        type: Array,
        default:[]
    }
},
  emits: ["tabs"],
  setup(__props, { emit: __emit }) {

const store = useStore();


const asideIndes = ref<number>(0);


// 定义 emit 事件
const emit = __emit;
// const asideList = reactive([
//     {
//         name: '子账号管理',
//         url:'/achievements'
//     },
//     {
//         name: '角色管理',
//         url: '/roleManage'
//     },
//     {
//         name: ' 组织管理',
//         url: '/department'
//     }
// ])
const props = __props

onMounted(() => {
    const t = Session.get('asideIndes')
    asideIndes.value = Session.get('asideIndes')? Session.get('asideIndes'):0
    console.log('fsdfsd',t)
})

const tabs = (item:any,i:number) => {
    console.log('打印',i)
    // router.push(item.url)
    emit('tabs', item.url);
    Session.set('asideIndes',i)
    asideIndes.value = i
}

// 页面加载时
onMounted(() => {

})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.asideList, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["aside", asideIndes.value == index?'active':'']),
        key: index,
        onClick: ($event: any) => (tabs(item,index))
      }, _toDisplayString(item.name), 11, _hoisted_2))
    }), 128))
  ]))
}
}

})